import api from '@/api'
import {
  INIT_SEARCH_DATA,
  SET_SALES_MAN_LIST,
  SET_ACTIVE_TAB,
  SET_SEARCH_DATA,
  SET_FEE_TYPE,
} from './mutation-types'
import {objectTrim, getHeaderName, getContentType} from '@/utils'
import { i18n } from '@/i18n'
import files from 'file-saver'
import {TabType} from '../../../views/User/components/userBillDetail/constant'
import {FeeType} from '@/constants'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  startTime: null,
  endTime: null,
  userName: '',
  userId: null,
  billNo: '',
  platform: null,
  amdinId: null,
  projectName: '',
  company: '',
  feeType: null,
  nodeType: null,
  payStatus: null,
  isRelated: 1,
  timeZone: '+08:00',
})

const ExportFile = new Map([
  [TabType.overview, api.userApi.exportUserMonthBillBriefList],
  [TabType.quantityDetail, api.userApi.exportUserBillDetails],
  [TabType.render, api.userApi.exportPictureMemberConsumeList],
])

const state = {
  searchData: initQuery(),
  TabType: TabType,
  activeTab: TabType.overview,
  salesManList: [],
  feeType: FeeType.RENDER,
}

const mutations = {
  [INIT_SEARCH_DATA] (state, payload) {
    state.searchData = initQuery()
  },
  [SET_SALES_MAN_LIST](state, payload) {
    state.salesManList = payload
  },
  [SET_ACTIVE_TAB](state, payload) {
    state.activeTab = payload
  },
  [SET_SEARCH_DATA](state, payload) {
    state.searchData = {
      ...state.searchData,
      ...payload,
    }
  },
  [SET_FEE_TYPE](state, payload) {
    state.feeType = payload
  },
}

const getters = {
  isDesktop(state) {
    return state.feeType === FeeType.DESKTOP
  },
  isDesktopDetail(state) {
    return state.activeTab === TabType.desktop
  },
}

const actions = {
  async getSalesManList({ commit }, payload) {
    const { data } = await api.userApi.queryAdminByOrganizationType({ organizationType: payload })
    commit(SET_SALES_MAN_LIST, data)
  },
  initQuery({ commit }) {
    commit(INIT_SEARCH_DATA)
  },
  setActiveTab({ commit }, payload) {
    commit(SET_ACTIVE_TAB, payload)
  },
  setFeeType({ commit }, payload) {
    commit(SET_FEE_TYPE, payload)
  },
  changeSearchData({ commit }, payload) {
    commit(SET_SEARCH_DATA, payload)
  },
  async getUserMonthBillBriefs({ commit, dispatch }, payload) {
    const res = await api.userApi.getUserMonthBillBriefs(payload)
    return res
  },
  async getUserMonthBills({ commit, dispatch }, payload) {
    const res = await api.userApi.getUserMonthBills(payload)
    return res
  },
  async downloadUserMonthBill({ commit, getters }, payload) {
    const _api = getters.isDesktop ? api.userApi.downloadCloudProductionBills : api.userApi.downloadUserMonthBill
    const { data, headers } = await _api(payload)
    const fileName = getHeaderName(headers)
    const mineType = getContentType(headers, 'content-type')
    const blob = new Blob([data], { type: mineType })
    files.saveAs(blob, fileName)
  },
  async getUserBillDetails({ commit, dispatch }, payload) {
    const res = await api.userApi.getUserBillDetails(payload)

    return res
  },
  async getPictureMemberConsumeList({ commit }, payload) {
    const res = await api.userApi.getPictureMemberConsumeList(payload)
    return res
  },
  async exportUserBillDetails({ state, dispatch }, {tab, params}) {
    const { platform } = params
    const otherParams = platform ? { platformName: i18n.t(`common_platform_${platform}`) } : null

    const req = objectTrim({...otherParams, pageNum: null, pageSize: null}, false, true)
    const formattedParams = objectTrim(params, false, true)
    const _params = {
      ...req,
      ...formattedParams,
    }
    const res = await ExportFile.get(tab)(_params)
    return res
  },
  async exportFrameConsumeList({ state }, { params }) {
    const { platform } = params
    const req = objectTrim({...state.searchData, platformName: platform ? i18n.t(`common_platform_${platform}`) : undefined, pageNum: null, pageSize: null}, false, true)
    const formattedParams = objectTrim(params, false, true)
    if (params.userId && req.userName) {
      delete req.userName
    }
    const res = await api.userApi.exportFrameConsumeList({...req, ...formattedParams})
    return res
  },
  async exportHardwareConsumeList({ state }, { params }) {
    const formattedParams = objectTrim(params, false, true)
    const res = await api.userApi.exportUserBillByHardware({...formattedParams})
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
